<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">
                Adverse and Serious Adverse Events Report
            </h2>

            <p class="tw-italic tw-text-gray-700">
                Adverse events and serious adverse events per incident, symptom,
                or diagnosis reporting.
            </p>
        </b-container>

        <b-container fluid class="tw-my-5">
            <b-row>
                <b-col lg="4">
                    <multiselect
                        v-model="type_value"
                        :options="type_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder="Event Type (All Selected)"
                    ></multiselect>
                </b-col>
                <b-col lg="4">
                    <multiselect
                        v-model="detail_value"
                        :options="detail_options"
                        placeholder="Detail Rollup"
                    ></multiselect>
                </b-col>
                
            </b-row>
            <br />
            <b-row>
                <b-col lg="3">
                    <b-form-datepicker
                        id="start_date"
                        v-model="start_date"
                        placeholder="Start Date"
                        class="mb-2"
                        reset-button
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col lg="3">
                    <b-form-datepicker
                        id="end_date"
                        :min="start_date"
                        v-model="end_date"
                        placeholder="End Date"
                        class="mb-2"
                        reset-button
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col lg="2">
                    <b-form-select
                        v-model="study_phase"
                        :options="study_phase_options"
                        placeholder="Study Phase"
                    ></b-form-select>
                </b-col>
                <b-col lg="3">
                    <b-button @click="search_button_click">Apply</b-button>
                </b-col>
            </b-row>
        </b-container>

        <b-card no-body>
            <b-tabs card fill>
                <b-tab :title="'LIVE DATA'" active>
                    <b-card-text>
                        <b-button
                            variant="success"
                            v-if="live_download_in_progress"
                            disabled
                            class="float-right"
                            >Downloading...
                            <i class="fas fa-spin fa-spinner"></i
                        ></b-button>

                        <b-button
                            variant="success"
                            v-if="
                                (live_download_in_progress == false) &
                                (loading == false)
                            "
                            class="float-right"
                            @click="request_report()"
                            >Request Results as CSV</b-button
                        >
                        <b-button
                            variant="warning"
                            v-if="
                                (live_download_in_progress == false) &
                                (loading == false)
                            "
                            class="float-right"
                            style="margin-right: 20px"
                            @click="save_report()"
                            >Save As Report</b-button
                        >
                        <br /><br />
                        <b-alert v-if="loading" show
                            >Fetching data...
                            <i class="fas fa-spin fa-spinner"></i
                        ></b-alert>
                        <b-container class="tw-overflow-x-scroll"> <!--Add a scrollbar if the table is too wide-->
                            <b-table
                                ref="live_table"
                                striped
                                hover
                                :fields="live_fields"
                                :items="search"
                                :current-page="live_currentPage"
                                :per-page="perPage"
                            >
                            </b-table>
                        </b-container>

                        <b-row v-if="live_totalRows > perPage">
                            <b-col sm="12" md="12" class="my-1">
                                <b-pagination
                                    v-model="live_currentPage"
                                    :total-rows="live_totalRows"
                                    :per-page="perPage"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                                ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-tab>
                <b-tab :title="'SAVED REPORTS'">
                    <b-card-text>
                        <b-row>
                            <b-col lg="4">
                                Available Reports:
                                <b-form-select
                                    v-model="historical_date"
                                    :options="historical_dates"
                                    placeholder="Select A Report"
                                ></b-form-select>
                            </b-col>
                            <b-col lg="4">
                                <b-button
                                    variant="warning"
                                    v-if="making_snapshot"
                                    disabled
                                    class="float-left"
                                    style="position: relative; top: 26px"
                                    >Taking snapshot...
                                    <i class="fas fa-spin fa-spinner"></i
                                ></b-button>
                            </b-col>
                            <b-col lg="4" style="padding-top: 26px">
                                <b-button
                                    variant="success"
                                    v-if="historic_download_in_progress"
                                    disabled
                                    class="float-right"
                                    >Downloading...
                                    <i class="fas fa-spin fa-spinner"></i
                                ></b-button>
                                <!-- <b-button
                                    variant="success"
                                    class="float-right"
                                    v-if="
                                        (historic_download_in_progress ==
                                            false) &
                                        (historic_loading == false)
                                    "
                                    @click="download_report()"
                                    >Download Table as CSV</b-button
                                > -->
                            </b-col>
                        </b-row>
                        <br /><br />

                        <b-alert v-if="historic_loading" show
                            >Fetching data...
                            <i class="fas fa-spin fa-spinner"></i
                        ></b-alert>
                        <b-table
                            striped
                            hover
                            ref="report_table"
                            :fields="fields"
                            :items="load_report"
                            :filter="filter"
                            :current-page="currentPage"
                            :per-page="perPage"
                        >
                        </b-table>

                        <b-row v-if="totalRows > perPage">
                            <b-col sm="12" md="12" class="my-1">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                                ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>

        <b-modal
            id="save_report_modal"
            size="lg"
            title="Save Results As Report"
            :ok-title="'Save Report'"
            @ok="make_report"
        >
            <p>
                Creating a report will save the currently selected filters for
                future reference. By doing so, new AE/SAE cases reported in the
                future, which match the currently selected filter criteria, will
                also appear in this report's results.
            </p>
            <hr />
            <p>
                Save Report As:
                <b-form-input
                    v-model="report_name"
                    placeholder="Name of Report"
                ></b-form-input>
            </p>
            <hr />

            <h4>Summary:</h4>
            <p>
                Event Types:
                <span v-if="type_value">
                    <span
                        v-for="(element, index) in type_value"
                        v-bind:key="element"
                    >
                        <span v-if="index != 0">, </span>{{ element }}
                    </span>
                </span>

                <span v-else>All</span><br />

                Rollup: {{ detail_value }} <br />
                Start Date: <span v-if="start_date">{{ start_date }}</span>
                <span v-else>Beginning of Time</span><br />

                End Date: <span v-if="end_date">{{ end_date }}</span>
                <span v-else>End of Time</span>
            </p>
        </b-modal>

        <b-modal
            id="request_report_modal"
            size="lg"
            title="Request Report"
            :ok-title="'Submit'"
            @ok="download_live"
        >
            <p>
               The search parameters entered will be used to generate a CSV report, and
               a link will be sent to your email address to download once it is ready.
            </p>
            <hr />
            <p>
                Send link to:
                <b-form-input
                    v-model="report_email"
                    placeholder="youremail@someplace.com"
                ></b-form-input>
            </p>
        </b-modal>
    </div>
</template>


<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
    mixins: [DashboardBaseTemplate],
    components: {},
    data: function () {
        return {
            study_phase: null,
            study_phase_options: [
                {
                    value: null,
                    text: 'Any'
                },
                'Baseline',
                'Cohort 1',
                'Cohort 2'
            ],
            type_options: [
                "Subject Adverse Events",
                "Non-Subject Adverse Events",
                "Subject Serious Adverse Events",
                "Non-Subject Serious Adverse Events",
            ],
            type_value: null,
            detail_options: [
                "Incident Case Rollup",
                "Per Symptom",
                "Per Diagnosis",
                "Per Symptom-Diagnosis Link",
            ],
            detail_value: "Incident Case Rollup",
            /* Historic Table */
            fields: [],
            perPage: 15,
            totalRows: 1,
            currentPage: 1,
            events: [],
            making_snapshot: false,
            historical_dates: [],
            historical_date: null,
            historic_download_in_progress: false,
            historic_loading: false,
            /* Live Table */
            live_fields: [],
            live_totalRows: 1,
            live_currentPage: 1,
            live_events: [],
            live_download_in_progress: false,
            componentKey: 0,
            filter: null,
            loading: false,
            report_csv_src:
                process.env.VUE_APP_AXIOS_BASE_URL +
                "/kenya/subject-final-status-report-csv",
            start_date: null,
            end_date: null,
            report_name: null,
            report_email: null,
        };
    },
    computed: {
        ...mapState("user", ["user", "myGroups"]),
        ...mapGetters("user", ["inMyGroups"]),
    },
    watch: {
        historical_date: function () {
            this.$refs.report_table.refresh();
        },
    },
    created: function() {
        if(this.STUDY == 'mali'){
            this.study_phase_options = [
                {
                    value: null,
                    text: 'Any'
                },
                'Baseline',
                'Intervention'
            ];
        }
    },
    mounted: function () {
        let that = this;
        HTTP.get("/kenya/ae-sae-report/get-reports")
            .then((response) => {
                that.historical_dates = response.data;
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
            });
    },
    methods: {
        ...mapActions("subjectfinalstatuscompleted", [
            "getSubjectFinalCompletedCount",
            "setSubjectFinalCompletedCount",
        ]),
        refreshSideNavCount() {
            this.getSubjectFinalCompletedCount().then((response) => {
                this.setSubjectFinalCompletedCount(response.data);
            });
        },
        searchAll: function () {
            // do the regular search regardless
            this.search(false);

            // but if we have a historical date selected, make sure to update that search too
            if (this.historical_date != null) {
                this.search(true);
            }
        },
        save_report: function () {
            this.$bvModal.show("save_report_modal");
        },

        request_report: function() {
            this.$bvModal.show('request_report_modal');
        },

        make_report: function () {
            let that = this;
            // make sure we have dates selected
            if (that.report_name == null) {
                alert("You must specify a report name.");
                return;
            }

            that.making_snapshot = true;
            const fd = new FormData();
            fd.append("types", that.type_value);
            fd.append("rollup", that.detail_value);
            fd.append("start_date", that.start_date);
            fd.append("end_date", that.end_date);
            fd.append("name", that.report_name);

            HTTP.post("/kenya/ae-sae-report/make-report", fd)
                .then((response) => {
                    if (response.data == "Report exists") {
                        alert("A report already exists with that name.");
                        that.making_snapshot = false;
                        return;
                    }
                    that.historical_dates.push(response.data);
                    that.historical_date = response.data.value;
                    that.making_snapshot = false;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                    that.making_snapshot = false;
                });
        },
        download_report: function () {
            let that = this;
            let request_string =
                "/kenya/ae-sae-report/load-report?f=csv&report=" +
                that.historical_date;
            that.historic_download_in_progress = true;

            HTTP.get(request_string, {
                responseType: "arraybuffer",
            })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                        "download",
                        that.historical_date + ".csv"
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    that.historic_download_in_progress = false;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                    that.historic_download_in_progress = false;
                });
        },
        load_report: function (ctx) {
            let that = this;
            that.loading = true;
            let params = {
                f: 'json',
                report: that.historical_date,
                page: ctx.currentPage,
                perpage: ctx.perPage,
            }
            if (that.start_date != null) {
                params.start_date = that.start_date
            }
            if (that.end_date != null) {
                params.end_date = that.end_date
            }

            return HTTP.get("/kenya/ae-sae-report/search", {
                params: params
            })
                .then(response => {
                    that.fields = response.data.fields;                
                    that.events = response.data.data;
                    that.totalRows = response.data.total;
                    that.loading = false;
                    return that.events;
                })
                .catch(error => {
                    HandleErrors.HandleErrors(error);
                    return [];
                });
        },
        download_live: function () {
            let that = this;
            let request_string =
                "/kenya/ae-sae-report/request-report?detail=" +
                that.detail_value +
                "&type=" +
                that.type_value + 
                "&email=" + 
                that.report_email

            if (that.start_date != null) {
                request_string += "&start_date=" + that.start_date;
            }
            if (that.end_date != null) {
                request_string += "&end_date=" + that.end_date;
            }
            if (that.study_phase != null) {
                request_string += "&study_phase=" + that.study_phase
            }

            HTTP.get(request_string)
                .then((response) => {
                    alert("A report will be emailed to you shortly.");
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                    that.historic_download_in_progress = false;
                });
        },
        search_button_click: function(){
            this.$refs.live_table.refresh();
        },
        search: function (ctx) {
            let that = this;
            that.loading = true;
            // ------------------------------------

            // let params = {
            //     f: 'json',
            //     detail: that.detail_value,
            //     type: that.type_value,
            //     page: ctx.currentPage,
            //     perpage: ctx.perPage,
            // }
            // if (that.start_date != null) {
            //     params.start_date = that.start_date
            // }
            // if (that.end_date != null) {
            //     params.end_date = that.end_date
            // }
            // if (that.study_phase != null) {
            //     params.study_phase = that.study_phase
            // }

            // return HTTP.get("/kenya/ae-sae-report/search", {
            //     params: params
            // })

            // ------------------------------------

            let request_string =
                "/kenya/ae-sae-report/search?f=json&detail=" +
                that.detail_value +
                "&type=" +
                that.type_value + 
                "&email=" + 
                that.report_email +
                "&page=" +
                ctx.currentPage +
                "&perpage=" +
                ctx.perPage

            if (that.start_date != null) {
                request_string += "&start_date=" + that.start_date;
            }
            if (that.end_date != null) {
                request_string += "&end_date=" + that.end_date;
            }
            if (that.study_phase != null) {
                request_string += "&study_phase=" + that.study_phase
            }

            return HTTP.get(request_string)
            // ------------------------------------
                .then(response => {
                    that.live_fields = response.data.fields;                
                    that.live_events = response.data.data;
                    that.live_totalRows = response.data.total;
                    that.loading = false;
                    return that.live_events;
                })
                .catch(error => {
                    HandleErrors.HandleErrors(error);
                    return [];
                });
        },
    },
};
</script>

<style>
</style>